export interface WhatsNewEntry {
  id: string;
  date: string;
  title: string;
  description: string;
  image: string;
}

export const whatsNewEntries: WhatsNewEntry[] = [
  {
    id: "2026-02-28-ai-labels-control",
    date: "2026-02-28",
    title: "More control over AI Labels",
    description:
      "You can now choose exactly which data sources the AI uses to build your groups — getting sharper, more accurate results. Plus, manage groups manually for the first time: rename, delete, or add groups directly without rebuilding from scratch.",
    image:
      "https://cdn.prod.website-files.com/65783e649367bc55fecaea2d/699c3c8c443be36a224f2c72_Label.webp",
  },
  {
    id: "2026-02-28-filters-upgraded",
    date: "2026-02-28",
    title: "Filters, upgraded",
    description:
      "Filters are now faster and easier to work with. A redesigned creation flow, simpler value editing, and recent entries surfaced automatically. You can also set a default filter configuration from the Setup page so every session starts exactly where you want it.",
    image:
      "https://cdn.prod.website-files.com/65783e649367bc55fecaea2d/69a292dde6b04a38c7960964_Filters.webp",
  },
  {
    id: "2026-02-19-sort-impressions",
    date: "2026-02-19",
    title: "Sort competitor ads by impressions",
    description:
      "You can now sort all ads in the Competitor Ads tab by impressions, highest to lowest. The best-performing creatives surface to the top instantly, so you're not scrolling through hundreds of ads trying to figure out what's actually getting traction.",
    image:
      "https://cdn.prod.website-files.com/65783e649367bc55fecaea2d/69989edd5a62618087b87e9e_Impressions.webp",
  },
  {
    id: "2026-02-18-section-templates",
    date: "2026-02-18",
    title: "Create sections faster with Templates",
    description:
      'Starting today, adding a new section is simpler and more visual. Instead of starting from "Add section," you\'ll now see a template gallery so you can create common groupings (like **Creatives**, **Ad name**, **Adsets**, **Campaigns**, etc.) in one click, or quickly spin up **AI-powered groupings** using ready-made templates.',
    image:
      "https://cdn.prod.website-files.com/65783e649367bc55fecaea2d/69989edd583fa623e72eb393_Preset.webp",
  },
  {
    id: "2026-02-18-winner-stars",
    date: "2026-02-18",
    title: "Winners are now highlighted with Stars",
    description:
      "Now, any ad that meets your winning criteria is clearly marked as a winner in creative view so you can spot top performers at a glance.\n\nFor more control, you can set multiple winning criteria, and each criteria can have its own star color so you immediately know why something is winning (and which rule it's satisfying).",
    image:
      "https://cdn.prod.website-files.com/65783e649367bc55fecaea2d/69989eddb51e6a8a8a3ac059_Winner.webp",
  },
];

export function getRelativeLabel(dateStr: string): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  const entryDate = new Date(y, m - 1, d);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.round(
    (today.getTime() - entryDate.getTime()) / (1000 * 60 * 60 * 24),
  );
  if (diffDays <= 0) return "Updated today";
  if (diffDays === 1) return "Updated 1 day ago";
  return `Updated ${diffDays} days ago`;
}

export function groupEntriesByDate(
  entries: WhatsNewEntry[],
): { date: string; entries: WhatsNewEntry[] }[] {
  const grouped = new Map<string, WhatsNewEntry[]>();
  for (const entry of entries) {
    const existing = grouped.get(entry.date) || [];
    existing.push(entry);
    grouped.set(entry.date, existing);
  }
  return Array.from(grouped.entries())
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([date, entries]) => ({ date, entries }));
}
